// Tag color categories for special meaning
export const TAG_COLOR_OVERRIDES = {
  // Dark red - Unobtainable
  "unobtainable": "#991B1B",
  "partly discontinued/unobtainable": "#991B1B",
  
  // Light red - Risky/Missable
  "buggy -": "#DC2626",
  "missable": "#EF4444",
  "external content": "#EF4444",
  
  // Orange - Online/Multiplayer requirements
  "host only": "#F97316",
  "offline mode": "#F97316",
  "online required": "#F97316",
  "online skill": "#F97316",
  "community": "#F97316",
  "viral": "#F97316",
  "x number of players required": "#F97316",
  
  // Yellow - Time/Grind concerns
  "time-limited": "#EAB308",
  "grind": "#EAB308",
  "multiple playthroughs required": "#EAB308",
  "cumulative -": "#EAB308",
  
  // Blue - Multiplayer modes
  "multiplayer": "#3B82F6",
  "cooperative": "#2563EB",
  "versus": "#3B82F6",
  
  // Green - Positive/Easy
  "single player": "#22C55E",
  "buggy +": "#65A30D",
  "cumulative +": "#22C55E",
  "stackable": "#22C55E",
  "story completed": "#16A34A",
  
  // Purple - Story/Difficulty
  "main storyline": "#8B5CF6",
  "difficulty specific": "#EC4899",
  "level": "#8B5CF6",
  
  // Teal - Collectibles
  "collectible": "#14B8A6",
  "shop": "#14B8A6",
};

// Get the appropriate color for a tag (override or original)
export function getTagColor(tag) {
  if (!tag) return "#888888";
  const normalizedName = (tag.name || "").toLowerCase();
  return TAG_COLOR_OVERRIDES[normalizedName] || tag.color || "#888888";
}
